import { render, staticRenderFns } from "./CAxAALxLaborPage.vue?vue&type=template&id=5949512b"
import script from "./CAxAALxLaborPage.vue?vue&type=script&lang=js"
export * from "./CAxAALxLaborPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports